import React from 'react';
import Mytasks from '../MyTasks/MyTasks';

const Home = () => {


    return (
        <div className='container'>
            <Mytasks></Mytasks>
        </div>
    );
};

export default Home;